import { render, staticRenderFns } from "./vehicleRemoteSetting.vue?vue&type=template&id=1b62be54&scoped=true&"
import script from "./vehicleRemoteSetting.vue?vue&type=script&lang=js&"
export * from "./vehicleRemoteSetting.vue?vue&type=script&lang=js&"
import style0 from "./vehicleRemoteSetting.vue?vue&type=style&index=0&id=1b62be54&prod&scoped=true&lang=less&"
import style1 from "./vehicleRemoteSetting.vue?vue&type=style&index=1&id=1b62be54&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b62be54",
  null
  
)

export default component.exports